import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  useTheme,
} from "@mui/material";
import { useStyles } from "./styles";
import PropTypes from "prop-types";

const Tickbox = ({
  id,
  name,
  isChecked,
  setValue,
  dataTestId = "checkboxForm",
  color,
  labelColor,
  disabled = false,
  indeterminate = false,
}) => {
  const theme = useTheme();
  const classes = useStyles({ theme, color, labelColor });
  return (
    <FormGroup key={id} data-testid={dataTestId}>
      <FormControlLabel
        control={
          <Checkbox
            data-testid={"checkbox"}
            checked={isChecked}
            onChange={(e) => setValue(e)}
            className={classes.checkbox}
            name={name}
            disabled={disabled}
            indeterminate={indeterminate}
          />
        }
        label={
          <Typography className={classes.checkboxLabel}>{name}</Typography>
        }
      />
    </FormGroup>
  );
};

Tickbox.propTypes = {
  id: PropTypes.any,
  name: PropTypes.string,
  isChecked: PropTypes.bool,
  setValue: PropTypes.func,
  dataTestId: PropTypes.string,
  color: PropTypes.string,
  labelColor: PropTypes.string,
  icon: PropTypes.bool,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
};
export default Tickbox;
